import type { IAssembler, IAssemblerManager } from 'cc';

import NeutrinoComponentBase from './NeutrinoComponentBase';

export default class NeutrinoAssembler2D implements IAssembler {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public createData(comp: NeutrinoComponentBase) {}

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public removeData(data) {}

    public updateRenderData() {}

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public fillBuffers(comp: NeutrinoComponentBase, renderer /* : IBatcher */) {}
}

const neutrinoAssembler2D = new NeutrinoAssembler2D();

// eslint-disable-next-line @typescript-eslint/naming-convention
const NeutrinoAssembler2DAccessor: IAssemblerManager = {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getAssembler(comp: NeutrinoComponentBase) {
        return neutrinoAssembler2D;
    },
};

// v1.0 與 v1.1 共用同一個空 assembler，掛在共用基底上。
NeutrinoComponentBase.Assembler = NeutrinoAssembler2DAccessor;
